export default __webpack_public_path__ + "media/plus/transfer-visual-447baf9f.svg";